import { Injectable } from '@angular/core';
import { AllAgentsData } from '@app/home/services/models/our-specialists-model';
import { AgentsService } from '@app/home/services/agents.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as agentsActions from '../actions';

@Injectable()
export class AgentsEffects {
  getAllAgents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(agentsActions.getAllAgents),
      switchMap(({ filter }) => {
        return this._agentsService.getAllAgentsByFilter(filter).pipe(
          map((data) => {
            const startIndex = this.getStartIndex(filter);
            return agentsActions.getAllAgentsSuccess({
              agents: [
                ...data.content.map((a, i) => ({
                  ...a,
                  index: startIndex + i + 1,
                })),
              ],
              totalCount: data.totalElements,
            });
          }),
          catchError((err) => of(agentsActions.getAllAgentsFailure({ errorMessage: err.message }))),
        );
      }),
    );
  });

  getMoreAgents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(agentsActions.getMoreAgents),
      switchMap(({ filter }) => {
        return this._agentsService.getAllAgentsByFilter(filter).pipe(
          map((data) => {
            return agentsActions.getMoreAgentsSuccess({ agents: data.content, totalCount: data.totalElements });
          }),
          catchError((err) => of(agentsActions.getMoreAgentsFailure({ errorMessage: err.message }))),
        );
      }),
    );
  });

  constructor(
    private actions$: Actions,
    private _agentsService: AgentsService,
  ) {}

  getStartIndex(filter: AllAgentsData) {
    const pageSize = 10;
    const pageNumber = filter.pageNumber;
    const topAgentFlagsIds = filter.topAgentFlagsIds || [];

    let indexOffset = 0;
    if (topAgentFlagsIds.includes(102)) {
      indexOffset = 10;
    } else if (topAgentFlagsIds.includes(103)) {
      indexOffset = 50;
    }

    return pageNumber * pageSize + indexOffset;
  }
}
